import request from '@/utils/request';

// 记录访问记录
export function postAccessInfo(data) {
  return request({
    url: `/app-server/marketui/accessInfo`,
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/accessInfo.js